import { ComponentProps } from 'react';
import { styled } from 'styled-components';
import { Slider as LibSlider } from 'radix-ui';

export type SliderProps = ComponentProps<typeof Root>;

const Slider = (props: SliderProps) => (
  <Root defaultValue={[0]} {...props}>
    <Track className="SliderTrack">
      <Range className="SliderRange" />
    </Track>
    <Thumb className="SliderThumb" aria-label="Volume" />
  </Root>
);

const Root = styled(LibSlider.Root)`
  display: flex;
  align-items: center;
  height: 24px;
  position: relative;
  user-select: none;
  touch-action: none;
`;

const Track = styled(LibSlider.Track)`
  background-color: ${({ theme }) => theme.getColor('rgbaWhite50Color')};
  position: relative;
  flex-grow: 1;
  border-radius: 9999px;
  height: 10px;
  ${({ theme }) => theme.getUpMedia('md')} {
    height: ${({ theme }) => theme.responsive(8)};
  }
`;

const Range = styled(LibSlider.Range)`
  height: 100%;
  background-color: ${({ theme }) => theme.getColor('accentSecondary')};
  border-radius: 9999px;
  position: absolute;
`;

const Thumb = styled(LibSlider.Thumb)`
  display: block;
  width: 24px;
  height: 24px;
  background-color: ${({ theme }) => theme.getColor('accentSecondary')};
  border-radius: 50%;

  /*&:hover {
    background-color: var(--violet-3);
  }*/

  &:focus {
    outline: none;
  }

  &:before {
    content: '';
    display: block;
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.getColor('completelyWhite')};
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    ${({ theme }) => theme.getUpMedia('md')} {
      width: ${({ theme }) => theme.responsive(16)};
      height: ${({ theme }) => theme.responsive(16)};
    }
  }
`;

export { Slider };
